/**
 * Base64-encoded notification sound
 * This is a short, pleasant "ding" sound for notifications
 */
export const notificationSound = "data:audio/mp3;base64,SUQzBAAAAAAAI1RTU0UAAAAPAAADTGF2ZjU4Ljc2LjEwMAAAAAAAAAAAAAAA//tQwAAAAAAAAAAAAAAAAAAAAAAASW5mbwAAAA8AAAAUAAAH2AAHBwcHEREREREbGxsbGyUlJSUlLy8vLy85OTk5OUNDQ0NDTExMTExWVlZWVmBgYGBgampqampzc3Nzc319fX19h4eHh4eRkZGRkZubm5ubpaWlpaWvr6+vr7m5ubm5w8PDw8PNzc3Nzdfr6+vr9fX19fX///////////8AAAAATGF2YzU4LjEzAAAAAAAAAAAAAAAAJAYIAAAAAAAAB9jJ+O5sAAAAAP/7kMQAAAlkdYdBGAAhNxKn3vLgAADAcGwbBsGwbO+53IAgCAIHBuO47juu67u+4PgQBAEDgg+CAIAgaDg+D4IAgjWNY1jWNY1jWNY1jWNY1jWNY1jWNY1jWNY1kAQBAEAQBAEAQBAEAQBQcHwfB8HwfBAEAfB8HwfBAEAQBAEAUGwbBsGwbBsGwbBsGwbBsGwbBsGwbBsGwbBsGwbBsGwbBsGwbBsGwbBsGwbBsHBsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//uQxAAADZSlRbyYAKOQr2G81ACAAAAAAAAYxjGMYxjQBB8EAQczgCA4UBQTB8EAgcHM4DgQFAMDwYHBMHwQCAMDwQBAMGwfBjOA4PhQTCAKCYQBQMGwfCAmDIMDwoBhATCAKBgGD4MEwgCgmEA0Gg4FBMICYQBQTCAmEAUDgYNg+EBMICYQEwgCgcGwfCAKBg2DAMGwbBsGwbBsGAIAgCDoMYxjGMYxjGMYxjGMYxjGMYxjGMYxjGMYxjGMYxjGMYxjGMYxjGMYxjGMYxjGP/+5DEAAAOZ5fSfnPAAeALCv/MeAAAAAAYxjGMYxjGMYxjGMYxjGMYxjGMYxjGMYxjGMYxjAAYMDAwMDAwMDAwMDAwMDAwMDw8PDw8PDw8PDw8PDw8PDw8QEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAAQEBAQEBAQEBAQEBAQEBAQEBAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEA==";

/**
 * Play notification sound
 */
export const playNotificationSound = () => {
  try {
    const audio = new Audio(notificationSound);
    audio.volume = 0.5; // Set volume to 50%
    audio.play();
  } catch (error) {
    console.error('Error playing notification sound:', error);
  }
};

export default {
  notificationSound,
  playNotificationSound
}; 